import makeStyles from "@material-ui/core/styles/makeStyles";

export const useStyles = makeStyles(theme => ({
  alert: {
    position: "relative",
    width: "50%",
    margin: '1vh 25%'
  }
}));
